import { APICore } from './apiCore'

const api = new APICore()

function getOptionAnswers (params) {
  const baseUrl = '/option-answer'
  return api.get(baseUrl, params)
}

function getOptionAnswer (id) {
  const baseUrl = `/option-answer/${id}`
  return api.get(baseUrl, {})
}

function addOptionAnswer (params) {
  const baseUrl = '/option-answer'
  return api.create(baseUrl, params)
}

function updateOptionAnswer (params) {
  const baseUrl = '/option-answer'
  return api.update(baseUrl, params)
}

function deleteOptionAnswer (params) {
  const baseUrl = '/option-answer'
  return api.delete(baseUrl, params)
}

export { getOptionAnswers, getOptionAnswer, addOptionAnswer, updateOptionAnswer, deleteOptionAnswer }
